// src/components/FooterOfficina.jsx
import React from "react";
import { useTranslation } from "react-i18next";

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const FooterOfficina = ({ country }) => {
  const locale = getLocaleFromCookie();

  const getLocalizedCountry = (code) => {
    try {
      return new Intl.DisplayNames([locale], { type: "region" }).of(code);
    } catch {
      return code;
    }
  };

  const localizedCountry = country ? getLocalizedCountry(country) : "";
  const { t } = useTranslation();

  return (
    <div className="container mt-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <p className="mb-1 text-black small">
            <strong>{t("officina.intro")}</strong>
	  		<br />
            {t("officina.description1")}
	  		<br />
            {t("officina.description2")}
	  		<br />
            {t("officina.description3")}
	  		<br />
            {t("officina.description4")}			
          </p>
        </div>
      </div>
    </div>
  );
};

export default FooterOfficina;
